import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Select,
  Space,
  Table
} from "antd";
import type { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import {
  collection,
  onSnapshot,
  query
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PageTitle } from "../../components";
import { db } from "../../firebase";

interface DataType {
  key: string;
  lastName: string;
  firstName: string;
  date: string;
}

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailLayout = {
  wrapperCol: { offset: 6, span: 18 },
};

const deleteArcher = async (user: any) => {
  // await deleteDoc(doc(db, "users", user.key));
  // message.success(
  //   `"${user.lastName} ${user.firstName}" харваач амжилттай устгалаа.`
  // );
};

const { Option } = Select;

function Ranking() {
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [data, setData] = useState<DataType[]>([]);
  const [oldData, setOldData] = useState<DataType[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchKey, setSearchKey] = useState("firstName");
  const [searchValue, setSearchValue] = useState<any>(null);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const ranks = useSelector((state: any) => state.content.ranks);
  const teams = useSelector((state: any) => state.content.teams);
  const userData = useSelector((state: any) => state.authentication.userData);

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, "users")),
      (querySnapshot) => {
        const comps: DataType[] = [];

        querySnapshot.forEach((doc: any) => {
          const docData = doc.data();
          if (docData?.role !== "archer") return;
          comps.push({ ...docData, key: doc.id });
        });
        comps.sort((a: any, b: any) => a.firstName.localeCompare(b.firstName));

        setLoading(false);
        setData(comps);
        setOldData(comps);
      }
    );

    return unsub;
  }, []);

  const onFinish = () => {
    setLoading(true);

    const comps: DataType[] = oldData.filter((item: any): boolean =>
      item[searchKey]?.toLowerCase().includes(searchValue?.toLowerCase())
    );

    setLoading(false);
    setData(comps);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const clearSearchForm = () => {
    searchForm.resetFields();
    setSearchValue(null);
    setData(oldData);
  };
  const getRanking = () => {};
  const columns: ColumnsType<DataType> = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      render: (text, row, index) => <>{index + 1}</>,
    },
    {
      title: "Чансаа",
      dataIndex: "totalChansaa",
      key: "totalChansaa",
      defaultSortOrder: "ascend",
      sorter: (a: any, b: any) => a.totalChansaa - b.totalChansaa,
    },
    {
      title: "Овог",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Нэр",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Регистрийн дугаар",
      dataIndex: "ssn",
      key: "ssn",
    },
    {
      title: "Улсын цол",
      dataIndex: "rankId",
      key: "rankId",
      render: (value, record) => {
        const currentRank = ranks[value];

        return currentRank ? (
          currentRank.name
        ) : (
          <span style={{ color: "red" }}>Цол сонгоогүй</span>
        );
      },
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => a.currentRank - b.currentRank,
    },
    {
      title: "Улсын цол авсан огноо",
      dataIndex: "rateDate",
      key: "rateDate",
      render: (value) => {
        return dayjs(value).format("YYYY-MM-DD");
      },
    },
    {
      title: "Спортын зэрэг",
      dataIndex: "rate2",
      key: "rate2",
      render: (value, record) => {
        const currentRank = ranks[value];

        return currentRank ? (
          currentRank.name
        ) : (
          <span style={{ color: "red" }}>Цол сонгоогүй</span>
        );
      },
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => a.currentRank - b.currentRank,
    },
    {
      title: "Спортын зэрэг авсан огноо",
      dataIndex: "rateDate2",
      key: "rateDate2",
      render: (value) => {
        return dayjs(value).format("YYYY-MM-DD");
      },
    },
    {
      title: "Баг",
      dataIndex: "teamId",
      key: "teamId",
      render: (value, record) => {
        const currentTeam = teams[value];

        return currentTeam ? (
          currentTeam.name
        ) : (
          <span style={{ color: "red" }}>Баг сонгоогүй</span>
        );
      },
    },
    {
      title: "Имэйл хаяг",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Утасны дугаар",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Үйлдэл",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/archers/${record.key}`} key={record.key}>
            Засах
          </Link>
          {/* <Popconfirm
            title="Устгахдаа итгэлтэй байна уу?"
            onConfirm={() => deleteArcher(record)}
            okText="Тийм"
            cancelText="Үгүй"
          >
            <Button type="link">Устгах</Button>
          </Popconfirm> */}
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTitle
        title="Харваачид"
        description="Харваачдын чансаа"
        right={
          userData.role === "admin" ? (
            <> </>
          ) : (
            <>
              <Button
                shape="round"
                onClick={() => setVisible(true)}
                icon={<PlusOutlined />}
                size="large"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Харваач нэмэх
              </Button>
              {/* <Button
                shape="round"
                onClick={() => checkJson()}
                icon={<PlusOutlined />}
                size="large"
              >
                Импорт {oldData.length}
              </Button> */}
            </>
          )
        }
      />
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12">
                      <Form
                        layout="inline"
                        style={{ marginBottom: 10 }}
                        form={searchForm}
                        initialValues={{ type: searchKey }}
                      >
                        <Form.Item name="type" label="Талбар">
                          <Select
                            value={searchKey}
                            style={{ width: 300 }}
                            onChange={(val) => {
                              setSearchKey(val);
                              setSearchValue(null);
                            }}
                            allowClear
                          >
                            <Option value="lastName">Овогоор</Option>
                            <Option value="firstName">Нэрээр</Option>
                            <Option value="email">Имэйл хаягаар</Option>
                            <Option value="rankId">Цолоор</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name="name"
                          label="Хайх утга"
                          rules={[
                            {
                              required: true,
                              message: "Хайх утга оруулна уу!",
                            },
                          ]}
                        >
                          {searchKey === "rankId" ? (
                            <Select
                              placeholder="Цол"
                              style={{ width: 200 }}
                              onChange={(val) => setSearchValue(val)}
                              allowClear
                            >
                              {Object.values(ranks)
                                .sort((a: any, b: any) => a.order - b.order)
                                .map((rank: any) => (
                                  <Option key={rank.id} value={rank.id}>
                                    {rank.name}
                                  </Option>
                                ))}
                            </Select>
                          ) : (
                            <Input
                              onChange={(e: any) =>
                                setSearchValue(e.target.value)
                              }
                              defaultValue={searchValue}
                              value={searchValue}
                            />
                          )}
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                          <Button
                            type="primary"
                            onClick={() => onFinish()}
                            loading={loading}
                          >
                            Хайх
                          </Button>
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                          <Button
                            type="dashed"
                            onClick={() => clearSearchForm()}
                          >
                            Арилгах
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={data}
                      loading={loading}
                    />
                  </div>

                  {/* <Pagination
                    current={currentPage}
                    totalPages={totalPages}
                    prevAction={prevPage}
                    nextAction={nextPage}
                    changeAction={(num) => changePage(num)}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Ranking;
